import {
  CREATING_CONVERSATION_REQUEST, CREATING_CONVERSATION_SUCCEDDED, CREATING_CONVERSATION_FAILED,
  FETCHING_CONVERSATIONS_REQUEST, FETCHING_CONVERSATIONS_SUCCEDDED, FETCHING_CONVERSATIONS_FAILED, INVALIDATE_CONVERSATIONS,
  FETCHING_CONVERSATION_REQUEST, FETCHING_CONVERSATION_SUCCEDDED, FETCHING_CONVERSATION_FAILED, INVALIDATE_CONVERSATION,
  FETCHING_CONVERSATION_ASSET_ANALYTICS_REQUEST, FETCHING_CONVERSATION_ASSET_ANALYTICS_SUCCEDDED,
  FETCHING_CONVERSATION_ASSET_ANALYTICS_FAILED,
  UPDATING_SHARE_REQUEST, UPDATING_SHARE_SUCCEDDED, UPDATING_SHARE_FAILED,
  UPDATING_CONVERSATION_RECIPIENT_REQUEST, UPDATING_CONVERSATION_RECIPIENT_SUCCEDDED,
  ADD_ASSET_TO_SHARE, ADD_ASSET_TO_SHARE_SUCCEDDED, ADD_ASSET_TO_SHARE_FAILED,
  DELETING_CONVERSATION_REQUEST, DELETING_CONVERSATION_SUCCEDDED, DELETING_CONVERSATION_FAILED,
  RESENDING_CONVERSATION_REQUEST, RESENDING_CONVERSATION_SUCCEDDED, RESENDING_CONVERSATION_FAILED, ADD_ASSETS_TO_SHARE_SECTION_SUCCEDDED,
  FETCHING_MESSAGE_REQUEST, FETCHING_MESSAGE_SUCCEDDED, FETCHING_MESSAGE_FAILED,
  FETCHING_SHARE_RECIPIENTS_REQUEST, FETCHING_SHARE_RECIPIENTS_SUCCEDDED, FETCHING_SHARE_RECIPIENTS_FAILED, INVALIDATE_SHARE_RECIPIENTS,
  FETCHING_SHARE_ASSETS_REQUEST, FETCHING_SHARE_ASSETS_SUCCEDDED, FETCHING_SHARE_ASSETS_FAILED, UPDATING_CONVERSATION_RECIPIENT_FAILED,
  ADD_OPPORTUNITY_TO_SHARE, ADD_OPPORTUNITY_TO_SHARE_SUCCEEDED, ADD_OPPORTUNITY_TO_SHARE_FAILED,
  REMOVE_OPPORTUNITY_FROM_SHARE, REMOVE_OPPORTUNITY_FROM_SHARE_SUCCEEDED, REMOVE_OPPORTUNITY_FROM_SHARE_FAILED,
  FETCH_RECIPIENT_INFO, FETCHING_RECIPIENT_INFO_SUCCEEDED, FETCHING_RECIPIENT_INFO_FAILED,FETCHING_CONVERSATION_EVENTS,FETCHING_CONVERSATION_EVENTS_SUCCEEDED,FETCHING_CONVERSATION_EVENTS_FAILED,
  SEARCHING_ENTITIES_IN_SHARE_REQUEST, SEARCHING_ENTITIES_IN_SHARE_SUCCEDDED, SEARCHING_ENTITIES_IN_SHARE_FAILED, EXCLUDING_USER
} from './actionTypes.jsx';

import axios from 'axios';
import buildUrl from 'build-url-ts';
const apiUrl = `${process.env.REACT_APP_API_URL}`;


const CONVERSATIONS_BASE_URL = `${apiUrl}/api/2.1/conversations`;
const SHARE_BASE_URL = `${apiUrl}/api/2.0/shares`;
const VISITORS_URL = `${apiUrl}/api/2.0/visitors/`;

/**
* Create new conversation
*/
export function createConversation(conversationRequest) {
  return function (dispatch) {
    dispatch(creatingConversation());
    return axios({
      method: 'POST',
      url: CONVERSATIONS_BASE_URL,
      data: conversationRequest
    })
      .then(response =>
        dispatch(creatingConversationSuccedded(response.data))
      )
      .catch(error =>
        dispatch(creatingConversationFailed(error))
      )
  }
}

function creatingConversation() {
  return {
    type: CREATING_CONVERSATION_REQUEST
  }
}

function creatingConversationSuccedded(json) {
  return {
    type: CREATING_CONVERSATION_SUCCEDDED,
    payload: json
  }
}

function creatingConversationFailed(error) {
  return {
    type: CREATING_CONVERSATION_FAILED,
    payload: error
  }
}

/**
* Fetch conversations for given page
*/
export function fetchConversations(query, page, sortBy, orderBy, type) {
  return function (dispatch) {

    var data = {
      query: query,
      page: page,
      sort: sortBy,
      order: orderBy,
      type: type
    }

    dispatch(fetchingConversations(data));

    let url = buildUrl(SHARE_BASE_URL, {
      path: '/all'
    });

    return axios({
      method: 'POST',
      url: url,
      data: data
    })
      .then(response =>
        dispatch(fetchingConversationsSuccedded(response.data))
      )
      .catch(error =>
        dispatch(fetchingConversationsFailed(error))
      )
  }
}

function fetchingConversations(json) {
  return {
    type: FETCHING_CONVERSATIONS_REQUEST,
    payload: json
  }
}

function fetchingConversationsSuccedded(json) {
  return {
    type: FETCHING_CONVERSATIONS_SUCCEDDED,
    payload: json
  }
}

function fetchingConversationsFailed(error) {
  console.log(error);
  return {
    type: FETCHING_CONVERSATIONS_FAILED,
    payload: error
  }
}

export function invalidateConversations() {
  return {
    type: INVALIDATE_CONVERSATIONS,
    payload: []
  }
}

/**
* Fetch conversation for given id
*/
export function fetchConversation(id, type) {
  return function (dispatch) {
    dispatch(fetchingConversation(id));

    let url = buildUrl(SHARE_BASE_URL, {
      path: id
    });

    var params = {
      type: type
    }

    return axios({
      method: 'GET',
      url: url,
      params: params
    })
      .then(response =>
        dispatch(fetchingConversationSuccedded(id, response.data))
      )
      .catch(error =>
        dispatch(fetchingConversationFailed(id, error))
      )
  }
}

function fetchingConversation(id) {
  return {
    type: FETCHING_CONVERSATION_REQUEST,
    payload: id
  }
}

function fetchingConversationSuccedded(id, json) {
  return {
    type: FETCHING_CONVERSATION_SUCCEDDED,
    payload: {
      id: id,
      conversation: json
    }
  }
}

function fetchingConversationFailed(id, error) {
  console.log(error);
  return {
    type: FETCHING_CONVERSATION_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}

/**
 * Lite App Fetch Opportunity
 */

 export function fetchSharesByOpportunityId(id, page) {
  return function (dispatch) {
    dispatch(fetchingConversations());

    let url = buildUrl(SHARE_BASE_URL, {
      path: `opportunity-mappings/${id}?page=${page}&limit=20`
    });
    
    return axios({
      method: 'GET',
      url: url
    }).then(response =>
        dispatch(fetchingConversationsSuccedded(response.data))
    ).catch(error =>
        dispatch(fetchingConversationsFailed( error))
    )
  }
}


/**
* Invalidate conversations
*/
export function invalidateConversation(id) {
  return {
    type: INVALIDATE_CONVERSATION,
    payload: id
  }
}

/**
* Fetch conversation asset analytics
*/
export function fetchAssetAnalytics(conversationID, sectionID, assetID, type) {
  return function (dispatch) {
    dispatch(fetchingAssetAnalytics(conversationID, sectionID, assetID));

    let url = buildUrl(SHARE_BASE_URL, {
      path: `${conversationID}/assets/${assetID}/analytics`
    });

    var params = {
      type: type
    }

    return axios({
      method: 'GET',
      url: url,
      params: params
    })
      .then(response => {
        return dispatch(fetchingAssetAnalyticsSuccedded(conversationID, sectionID, assetID, response.data))
      })
      .catch(error => {
        return dispatch(fetchingAssetAnalyticsFailed(conversationID, sectionID, assetID, error))
      })
  }
}

function fetchingAssetAnalytics(conversationID, sectionID, assetID) {
  return {
    type: FETCHING_CONVERSATION_ASSET_ANALYTICS_REQUEST,
    payload: {
      conversationID, sectionID, assetID
    }
  }
}

function fetchingAssetAnalyticsSuccedded(conversationID, sectionID, assetID, json) {
  return {
    type: FETCHING_CONVERSATION_ASSET_ANALYTICS_SUCCEDDED,
    payload: {
      conversationID, sectionID, assetID, json
    }
  }
}

function fetchingAssetAnalyticsFailed(conversationID, sectionID, assetID, error) {
  return {
    type: FETCHING_CONVERSATION_ASSET_ANALYTICS_FAILED,
    payload: {
      conversationID, sectionID, assetID, error
    }
  }
}

/**
* Add Asset to Share
*/
export function addAssetsToShare(id, assets) {
  return function (dispatch) {
    dispatch(addingAssetsToShare(id));

    let url = buildUrl(SHARE_BASE_URL, {
      path: `${id}/assets`
    });

    return axios({
      method: 'PUT',
      url: url,
      data: assets
    })
      .then(response =>
        dispatch(addingAssetsToShareSuccedded(id, response.data))
      )
      .catch(error =>
        dispatch(addingAssetsToShareFailed(id, error))
      )
  }
}

function addingAssetsToShare(id) {
  return {
    type: ADD_ASSET_TO_SHARE,
    payload: id
  }
}

function addingAssetsToShareSuccedded(id, json) {
  return {
    type: ADD_ASSET_TO_SHARE_SUCCEDDED,
    payload: {
      id: id,
      share: json
    }
  }
}

function addingAssetsToShareFailed(id, error) {
  console.log(error);

  return {
    type: ADD_ASSET_TO_SHARE_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}

/**
* Add Asset to Share
*/
export function addAssetsToShareSection(id, assets) {
  return function (dispatch) {
    dispatch(addingAssetsToShare(id));

    let url = buildUrl(SHARE_BASE_URL, {
      path: `${id}/assets`
    });

    return axios({
      method: 'PUT',
      url: url,
      data: assets
    })
      .then(response =>
        dispatch(addingAssetsToShareSuccedded(id, response.data))
      )
      .catch(error =>
        dispatch(addingAssetsToShareFailed(id, error))
      )
  }
}

// function addingAssetsToShare(id) {
//   return {
//     type: ADD_ASSET_TO_SHARE,
//     payload: id
//   }
// }

// function addingAssetsToShareSuccedded(id, json) {
//   return {
//     type: ADD_ASSETS_TO_SHARE_SECTION_SUCCEDDED,
//     payload: {
//       id: id,
//       share: json
//     }
//   }
// }

// function addingAssetsToShareFailed(id, error) {
//   console.log(error);

//   return {
//     type: ADD_ASSET_TO_SHARE_FAILED,
//     payload: {
//       id: id,
//       error: error
//     }
//   }
// }

/**
* Update share
*/
export function updateShare(conversationID, shareRequest) {
  return function (dispatch) {
    dispatch(updatingShare(conversationID));

    let url = buildUrl(SHARE_BASE_URL, {
      path: `${conversationID}`
    });

    return axios({
      method: 'PUT',
      url: url,
      data: shareRequest
    })
      .then(response =>
        dispatch(updatingShareSuccedded(conversationID, response.data))
      )
      .catch(error =>
        dispatch(updatingShareFailed(conversationID, error.response.data))
      )
  }
}

function updatingShare(conversationID) {
  return {
    type: UPDATING_SHARE_REQUEST,
    payload: conversationID
  }
}

function updatingShareSuccedded(conversationID, json) {
  return {
    type: UPDATING_SHARE_SUCCEDDED,
    payload: {
      conversationID: conversationID,
      share: json
    }
  }
}

function updatingShareFailed(conversationID, error) {
  return {
    type: UPDATING_SHARE_FAILED,
    payload: {
      conversationID: conversationID,
      error: error
    }
  }
}

/**
* Activate Conversation Recipient
*/
export function activateRecipient(conversationID, recipientID) {
  return function (dispatch) {
    dispatch(updatingRecipient(conversationID, recipientID));

    let url = buildUrl(SHARE_BASE_URL, {
      path: `${conversationID}/recipient/${recipientID}/activate`
    });

    return axios({
      method: 'PUT',
      url: url,
    })
      .then(response =>
        dispatch(updatingRecipientSuccedded(conversationID, recipientID, response.data))
      )
      .catch(error =>
        dispatch(updatingRecipientFailed(conversationID, recipientID, error))
      )
  }
}

/**
* Deactivate Conversation Recipient
*/
export function deactivateRecipient(conversationID, recipientID) {
  return function (dispatch) {
    dispatch(updatingRecipient(conversationID, recipientID));

    let url = buildUrl(SHARE_BASE_URL, {
      path: `${conversationID}/recipient/${recipientID}/deactivate`
    });

    return axios({
      method: 'DELETE',
      url: url,
    })
      .then(response =>
        dispatch(updatingRecipientSuccedded(conversationID, recipientID, response.data))
      )
      .catch(error =>
        dispatch(updatingRecipientFailed(conversationID, recipientID, error))
      )
  }
}


function updatingRecipient(conversationID, recipientID) {
  return {
    type: UPDATING_CONVERSATION_RECIPIENT_REQUEST,
    payload: {
      conversationID, recipientID
    }
  }
}

function updatingRecipientSuccedded(conversationID, recipientID, recipient) {
  return {
    type: UPDATING_CONVERSATION_RECIPIENT_SUCCEDDED,
    payload: {
      conversationID, recipientID, recipient
    }
  }
}

function updatingRecipientFailed(conversationID, recipientID, error) {
  return {
    type: UPDATING_CONVERSATION_RECIPIENT_FAILED,
    payload: {
      conversationID, recipientID, error
    }
  }
}

/**
* Resend  conversation
*/
export function resendConversation(conversationID, shareID, recipients) {
  return function (dispatch) {
    dispatch(resendingConversation(conversationID, shareID));

    let url = buildUrl(CONVERSATIONS_BASE_URL, {
      path: `${conversationID}/resend`
    });

    return axios({
      method: 'PUT',
      url: url,
      data: recipients
    })
      .then(response =>
        dispatch(resendingConversationSuccedded(conversationID, shareID, response.data))
      )
      .catch(error =>
        dispatch(resendingConversationFailed(conversationID, shareID, error))
      )
  }
}

function resendingConversation(conversationID, shareID) {
  return {
    type: RESENDING_CONVERSATION_REQUEST,
    payload: {
      conversationID, shareID
    }
  }
}

function resendingConversationSuccedded(conversationID, shareID, json) {
  return {
    type: RESENDING_CONVERSATION_SUCCEDDED,
    payload: {
      conversationID, shareID, json
    }
  }
}

function resendingConversationFailed(conversationID, shareID, error) {
  return {
    type: RESENDING_CONVERSATION_FAILED,
    payload: {
      conversationID, shareID, error
    }
  }
}

/**
 * Deleting Conversation
 */
export function deleteConversation(conversationID) {
  return function (dispatch) {
    dispatch(deletingConversation(conversationID));

    let url = buildUrl(SHARE_BASE_URL, {
      path: conversationID
    });

    return axios({
      method: 'DELETE',
      url: url
    })
      .then(() =>
        dispatch(deletingConversationSuccedded(conversationID))
      )
      .catch(error =>
        dispatch(deletingConversationFailed(conversationID, error))
      )
  }
}

function deletingConversation(conversationID) {
  return {
    type: DELETING_CONVERSATION_REQUEST,
    payload: conversationID
  }
}

function deletingConversationSuccedded(conversationID) {
  return {
    type: DELETING_CONVERSATION_SUCCEDDED,
    payload: conversationID
  }
}

function deletingConversationFailed(conversationID, error) {
  console.log(error);
  return {
    type: DELETING_CONVERSATION_FAILED,
    payload: {
      id: conversationID,
      error: error
    }
  }
}

/**
* Fetching Message
*/
export function fetchMessage(shareId) {
  return function (dispatch) {
    dispatch(fetchingMessage(shareId));

    let url = buildUrl(SHARE_BASE_URL, {
      path: `${shareId}/conversation`
    });

    return axios({
      method: 'GET',
      url: url
    })
      .then(response =>
        dispatch(fetchingMessageSuccedded(shareId, response.data))
      )
      .catch(error =>
        dispatch(fetchingMessageFailed(shareId, error))
      )
  }
}

function fetchingMessage(shareId) {
  return {
    type: FETCHING_MESSAGE_REQUEST,
    payload: shareId
  }
}

function fetchingMessageSuccedded(shareId, message) {
  return {
    type: FETCHING_MESSAGE_SUCCEDDED,
    payload: {
      shareId, message
    }
  }
}

function fetchingMessageFailed(shareId, error) {
  return {
    type: FETCHING_MESSAGE_FAILED,
    payload: {
      shareId, error
    }
  }
}


/**
* Fetch share recipients for given id
*/
export function fetchShareRecipients(id, page, sortBy, orderBy, filter) {
  return function (dispatch) {
    dispatch(fetchingShareRecipients(id, page));

    var params = {
      page: page,
      sortBy: sortBy,
      orderBy: orderBy,
      type: filter
    }

    let url = buildUrl(SHARE_BASE_URL, {
      path: `${id}/recipients`
    });

    return axios({
      method: 'GET',
      url: url,
      params: params
    })

      .then(response =>
        dispatch(fetchingShareRecipientsSuccedded(id, response.data))
      )
      .catch(error =>
        dispatch(fetchingShareRecipientsFailed(id, error))
      )
  }
}

function fetchingShareRecipients(id) {
  return {
    type: FETCHING_SHARE_RECIPIENTS_REQUEST,
    payload: id
  }
}

function fetchingShareRecipientsSuccedded(id, json) {
  return {
    type: FETCHING_SHARE_RECIPIENTS_SUCCEDDED,
    payload: {
      id: id,
      response: json
    }
  }
}

function fetchingShareRecipientsFailed(id, error) {
  console.log(error);
  return {
    type: FETCHING_SHARE_RECIPIENTS_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}

export function invalidateShareRecipients(id) {
  return {
    type: INVALIDATE_SHARE_RECIPIENTS,
    payload: id
  }
}

/**
* Fetch share assets for given id
*/
export function fetchShareAssets(id, type) {
  return function (dispatch) {
    dispatch(fetchingShareAssets(id));

    let url = buildUrl(SHARE_BASE_URL, {
      path: `${id}/assets`
    });


    var params = {
      type: type
    }

    return axios({
      method: 'GET',
      url: url,
      params: params
    })
      .then(response =>
        dispatch(fetchingShareAssetsSuccedded(id, response.data))
      )
      .catch(error =>
        dispatch(fetchingShareAssetsFailed(id, error))
      )
  }
}

function fetchingShareAssets(id) {
  return {
    type: FETCHING_SHARE_ASSETS_REQUEST,
    payload: id
  }
}

function fetchingShareAssetsSuccedded(id, json) {
  return {
    type: FETCHING_SHARE_ASSETS_SUCCEDDED,
    payload: {
      id: id,
      conversation: json
    }
  }
}

function fetchingShareAssetsFailed(id, error) {
  console.log(error);
  return {
    type: FETCHING_SHARE_ASSETS_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}

export function addOpportunityToShare(data, id) {
  return function (dispatch) {
    dispatch(addingOpportunityToShare(id));

    let url = buildUrl(SHARE_BASE_URL, {
      path: `${id}/opportunity`
    });

    return axios({
      method: 'POST',
      url: url,
      data: data
    })
      .then(response =>
        dispatch(addingOpportunityToShareSuccedded(response.data, id))
      )
      .catch(error =>
        dispatch(addingOpportunityToShareFailed(error, id))
      )
  }
}


function addingOpportunityToShare(id) {
  return {
    type: ADD_OPPORTUNITY_TO_SHARE,
    payload: {
      id: id
    }
  }
}


function addingOpportunityToShareSuccedded(json, id) {
  return {
    type: ADD_OPPORTUNITY_TO_SHARE_SUCCEEDED,
    payload: {
      data: json,
      id: id
    }
  }
}

function addingOpportunityToShareFailed(error, id) {
  return {
    type: ADD_OPPORTUNITY_TO_SHARE_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}


export function removeOpportunityToShare(id, opportunityId) {

  return function (dispatch) {
    dispatch(removingOpportunityToShare(id, opportunityId));

    let url = buildUrl(SHARE_BASE_URL, {
      path: `${id}/opportunity/${opportunityId}`
    });

    return axios({
      method: 'DELETE',
      url: url
    })
      .then(response =>
        dispatch(removingOpportunityToShareSuccedded(id, opportunityId, response.data))
      )

      .catch(error =>
        dispatch(removingOpportunityToShareFailed(id, opportunityId, error))
      )
  }
}

function removingOpportunityToShare(id, opportunity) {
  return {
    type: REMOVE_OPPORTUNITY_FROM_SHARE,
    payload: {
      id: id,
      opportunity: opportunity
    }
  }
}

function removingOpportunityToShareSuccedded(id, opportunity, json) {
  return {
    type: REMOVE_OPPORTUNITY_FROM_SHARE_SUCCEEDED,
    payload: {
      id: id,
      opportunity: opportunity,
      data: json
    }
  }
}

function removingOpportunityToShareFailed(id, opportunity, error) {
  return {
    type: REMOVE_OPPORTUNITY_FROM_SHARE_FAILED,
    payload: {
      id: id,
      opportunity: opportunity,
      error: error
    }
  }
}

export function fetchRecipientInfo(shareId, recipient) {

  return function (dispatch) {
    dispatch(fetchingRecipientInfo(shareId, recipient));

    let url = buildUrl(CONVERSATIONS_BASE_URL, {
      path: `${shareId}/recipients/${recipient}/activities`
    });


    return axios({
      method: 'GET',
      url: url
    })
    .then(response =>
      dispatch(fetchingRecipientInfoSuccedded(shareId, recipient, response.data))
    )
    .catch(error =>
      dispatch(fetchingRecipientInfoFailed(shareId, recipient, error))
    )
  }
}

function fetchingRecipientInfo(shareId, recipient) {
  return {
    type: FETCH_RECIPIENT_INFO,
    payload: {
      shareId: shareId,
      recipient: recipient
    }
  }
}

function fetchingRecipientInfoSuccedded(shareId, recipient, json) {
  return {
    type: FETCHING_RECIPIENT_INFO_SUCCEEDED,
    payload: {
      shareId: shareId,
      recipient: recipient,
      data: json
    }
  }
}

function fetchingRecipientInfoFailed(shareId, recipient, error) {
  return {
    type: FETCHING_RECIPIENT_INFO_FAILED,
    payload: {
      shareId: shareId,
      recipient: recipient,
      error: error
    }
  }
}

/**
* Search in Timeline
*/
export function searchEntitiesInShare(shareId, query) {
  return function (dispatch) {
    dispatch(searchingEntitiesInShare());

    let url = buildUrl(SHARE_BASE_URL, {
      path: `${shareId}/search`
    });

    var params = {
      query: query
    }

    return axios({
      method: 'GET',
      url: url,
      params: params
    })
     .then(response =>
        dispatch(searchingEntitiesInShareSuccedded(response.data))
      )
     .catch(error =>
        dispatch(searchingEntitiesInShareFailed(error))
     )
  }
}

function searchingEntitiesInShare() {
  return {
    type: SEARCHING_ENTITIES_IN_SHARE_REQUEST,
  }
}

function searchingEntitiesInShareSuccedded(json) {
  return {
    type: SEARCHING_ENTITIES_IN_SHARE_SUCCEDDED,
    payload: json
  }
}

function searchingEntitiesInShareFailed(error) {
  return {
    type: SEARCHING_ENTITIES_IN_SHARE_FAILED,
    payload: error
  }
}

/**
 * Fetch events for converstion
*/
export function fetchEventsForConversation(request, page, limit) {

  return function (dispatch) {
    dispatch(fetchingEventsForConversation(request, page, limit));

    let url = buildUrl(SHARE_BASE_URL, {
      path: '/events'
    });

    var params = {
      page: page,
      limit: limit
    }

    if(request.eventTypes.includes("all")) {
      request = {
        ...request,
        eventTypes: []
      }
    }

    return axios({
      method: 'POST',
      url: url,
      params: params,
      data: request
    })
    .then(response =>
      dispatch(fetchingEventsForConversationSuccedded(request, response.data))
    )
    .catch(error =>
      dispatch(fetchingEventsForConversationFailed(request, error))
    )
  }
}

function fetchingEventsForConversation(request, page) {
  return {
    type: FETCHING_CONVERSATION_EVENTS,
    payload: {
      request: request,
      page: page
    }
  }
}

function fetchingEventsForConversationSuccedded(request, json) {
  return {
    type: FETCHING_CONVERSATION_EVENTS_SUCCEEDED,
    payload: {
      request: request,
      data: json
    }
  }
}

function fetchingEventsForConversationFailed(request, error) {
  return {
    type: FETCHING_CONVERSATION_EVENTS_FAILED,
    payload: {
      request: request,
      error: error
    }
  }
}

// excluding user
export function exclusionVisitor(visitorId, shareId, recipient, exclusion) {
  return function (dispatch) {
    dispatch((excludingUser));
    let url = buildUrl(VISITORS_URL, {
      path: `/${visitorId}/exclusion/shares/${shareId}`
    });
    var queryParams = {
      exclusion: exclusion
    }
    return axios({
      method: 'PUT',
      url: url,
      params: queryParams
    })
    .then(response =>
        dispatch(fetchingRecipientInfoSuccedded(shareId, recipient, response.data))
        )
    .catch(error =>
        dispatch(fetchingRecipientInfoFailed(shareId, recipient, error))
    )
  }
}

function excludingUser(json) {
  return {
    type: EXCLUDING_USER,
    payload: json
  }
}